export const titleCase = (str) =>  
    typeof(str) === "string"? 
        String(str).split(" ").map((item) => item[0].toUpperCase() + item.substring(1)).join(" ")
    :
        null
    ;

